import { Skeleton, Table, type TableTdProps } from "@mantine/core"

export function TableSkeleton({ limit = 10, ...props }: TableTdProps & { limit?: number }) {
  return Array.from({ length: limit }).map((_, index) => (
    // biome-ignore lint: reason
    <Table.Tr key={index}>
      <Table.Td {...props}>
        <Skeleton height={40} />
      </Table.Td>
    </Table.Tr>
  ))
}
